import type { Entity } from '@models/Entity'

import { request } from '../../../gateways/api'
import type { AssignedBijlage } from '../types/AssignedBijlage'

export const reviewAssignedBijlageForEntity = async ({
  entity: { id: entityId, type },
  id,
  approved,
  reden,
  continued,
}: {
  entity: Entity
  id: string
  approved: boolean
  reden?: string
  continued?: boolean
}): Promise<AssignedBijlage> => {
  const { data } = await request({
    url: `/rest/${type}/${entityId}/bijlageassigned/${id}`,
    method: 'PATCH',
    data: {
      status: approved ? (continued ? 'assigned' : 'done') : 'uploaded',
      reden,
    },
  })

  return data
}
